import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Box, CircularProgress, Typography
} from '@mui/material';
import { gradientButtonSx, gradientTextSx } from '../../utils/colors';

const AddBatchModal = ({ onClose, onSubmit }) => {
  const [form, setForm] = useState({ code: '', name: '', description: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await onSubmit(form);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm"
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, pb: 0 }}>
        <Typography variant="h6" fontWeight={800} sx={gradientTextSx}>
          Create Batch
        </Typography>
      </DialogTitle>
      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <TextField
            label="Code *" name="code" value={form.code} onChange={handleChange}
            placeholder="e.g. 24Batch_CBC" required fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            label="Name *" name="name" value={form.name} onChange={handleChange}
            required fullWidth size="small"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <TextField
            label="Description" name="description" value={form.description}
            onChange={handleChange} fullWidth size="small" multiline rows={2}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <Button onClick={onClose} sx={{ textTransform: 'none', borderRadius: 2 }}>
            Cancel
          </Button>
          <Button
            type="submit" variant="contained" disabled={submitting}
            sx={{ ...gradientButtonSx, px: 3 }}
          >
            {submitting ? <CircularProgress size={18} color="inherit" /> : 'Create Batch'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AddBatchModal;
